import React from 'react';
import Stack from '@mui/material/Stack';

import MlstChip from './MlstChip';

function MlstBlock({ mlstResults }) {
  if (!mlstResults || mlstResults.length === 0) return null;

  // Keep the row-level display intentionally minimal for clinicians:
  // when multiple schemes are available, only show the top-ranked result.
  // "MLST: Not Determined" is derived by MlstChip/mlstUtils for non-typed statuses.
  const topResult = mlstResults[0];

  return (
    <Stack direction="row" spacing={0.5} flexWrap="wrap" useFlexGap>
      <MlstChip key={topResult.scheme} result={topResult} />
    </Stack>
  );
}

export default MlstBlock;
